import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Typography,
  IconButton,
  Paper
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import Alert from '../../utils/alert';

const useStyles = makeStyles((theme) => ({
  imageUploader: {
    width: '100%',
  },
  dropzone: {
    border: `2px dashed ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4),
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    backgroundColor: theme.palette.grey[50],
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
      borderColor: theme.palette.primary.dark,
    },
    '&:focus': {
      outline: 'none',
      borderColor: theme.palette.primary.dark,
      backgroundColor: theme.palette.grey[100],
    },
  },
  dropzoneText: {
    fontSize: '1.6rem',
    color: theme.palette.text.secondary,
    margin: 0,
    lineHeight: 1.5,
  },
  preview: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  previewItem: {
    position: 'relative',
    width: '120px',
    height: '120px',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
      boxShadow: theme.shadows[2],
    },
  },
  previewImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  removeButton: {
    position: 'absolute',
    top: '4px',
    right: '4px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '50%',
    padding: theme.spacing(0.5),
    minWidth: 'auto',
    width: '24px',
    height: '24px',
    color: theme.palette.error.main,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      transform: 'scale(1.1)',
    },
  },
}));

export default function MultipleImageUploader(props) {
  const classes = useStyles();
  const [files, setFiles] = useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: acceptedFiles => {
      let maxNum = props.maxNum ? props.maxNum : 4;
      acceptedFiles = acceptedFiles.concat(files);
      acceptedFiles.forEach((file, index) => {
        file.key = `photo_${index}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
      })

      if (acceptedFiles.length > maxNum) {
        Alert.error(`アップロードできる画像は${maxNum}個までです`)
        return;
      }

      //Setting previews
      setFiles(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })));
      //Callback function
      props.onImagesSelected(acceptedFiles);
    }
  });

  const thumbs = files.map((file, index) => (
    <Box className={classes.previewItem} key={file.key}>
      <img
        src={file.preview}
        alt="preview"
        className={classes.previewImage}
      />
      <IconButton
        className={classes.removeButton}
        size="small"
        onClick={() => {
          let updatedFiles = files.filter(value => value.key !== file.key)
          setFiles(updatedFiles);
          props.onImagesSelected(updatedFiles);
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  ));

  useEffect(() => () => {
    // Make sure to revoke the data uris to avoid memory leaks
    files.forEach(file => URL.revokeObjectURL(file.preview));
  }, [files]);

  return (
    <Box className={classes.imageUploader}>
      <Paper
        {...getRootProps({ className: classes.dropzone })}
        elevation={0}
      >
        <input {...getInputProps()} />
        <Typography className={classes.dropzoneText}>
          クリックして画像を選択<br />（あるいはここにファイルをドロップ）
        </Typography>
      </Paper>
      <Box className={classes.preview}>
        {thumbs}
      </Box>
    </Box>
  );
}